import { ResourceType } from '../../../../../backend';

export const CommonProperties = ['name', 'shortName', 'active', 'capacity', 'minTimeBetweenUse'];

export const UnsharedProperties: { type: ResourceType; value: string[] }[] = [
    { type: ResourceType.PARKING, value: ['occupationOffset', 'length', 'width', 'codeLetter', 'parkingZone'] },
    { type: ResourceType.TERMINAL, value: ['occupationOffset', 'surface', 'passengersBySquareMeter'] },
    { type: ResourceType.ARR_HALL, value: ['surface', 'passengersBySquareMeter', 'offsetSTA', 'terminal'] },
    { type: ResourceType.DEP_HALL, value: ['surface', 'passengersBySquareMeter', 'offsetSTD', 'terminal'] },
    { type: ResourceType.CHECK_IN, value: ['paxCapacity', 'terminal', 'zone', 'srb', 'dcs'] },
    { type: ResourceType.BOARDING_GATE, value: ['paxCapacity', 'departureHall'] },
];

export const getPropertiesListByType = (resourceType: ResourceType) =>
    UnsharedProperties.some(p => p.type === resourceType)
        ? CommonProperties.concat(UnsharedProperties.find(p => p.type === resourceType)!.value)
        : CommonProperties;
